import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import PhoneAndroidRoundedIcon from "@mui/icons-material/PhoneAndroidRounded";

export default function Footer() {
  const styles = {
    footer: {
      backgroundColor: "#ffffff",
      borderTop: "1px solid #e2e8f0",
      padding: "32px 16px",
      textAlign: "center",
      fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "16px",
    },
    link: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      color: "#475569",
      textDecoration: "none",
      fontSize: "14px",
      fontWeight: "500",
      transition: "color 0.2s ease",
    },
    copyright: {
      fontSize: "13px",
      color: "#94a3b8",
      margin: "8px 0 0 0",
    },
    icon: {
      fontSize: "18px",
      color: "#6366f1",
    },
  };

  return (
    <div className="footer" style={styles.footer}>
      <a
        href="mailto:Michal.Jaskulski@allworks.pl"
        style={styles.link}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#6366f1")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "#475569")}
      >
        <MailOutlineRoundedIcon style={styles.icon} />
        Michal.Jaskulski@allworks.pl
      </a>
      <a
        href="tel:+48602209858"
        style={styles.link}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#6366f1")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "#475569")}
      >
        <PhoneAndroidRoundedIcon style={styles.icon} />
        +48 602 209 858
      </a>
      <p style={styles.copyright}>
        &copy; 2026 Michał Jaskulski. Wszelkie prawa zastrzeżone.
      </p>
    </div>
  );
}
